











































import { Component, Mixins, Ref, Vue } from 'vue-property-decorator'
import TitleBase from '@/components/atoms/TitleBase.vue'
import TitleTextBase from '@/components/atoms/TitleTextBase.vue'
import SelectBase from '@/components/atoms/SelectBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import InputWithLabel from '@/components/molecules/InputWithLabel.vue'
import StudentInformationHistoryNursing from '@/components/organisms/nursing/StudentInformationHistory.vue'
import StudentInformationHistory from '@/components/organisms/StudentInformationHistory.vue'
import QueryMethods from '@/components/atoms/QueryMethods.vue'
import { StudentResponseType, GetStudentsResponseType } from '@/models/api/students'
import NursingBranch from '@/mixins/v3/NursingBranch'
import NotificationList, { Notification } from '@/components/organisms/NotificationList.vue'
import ModalNotification from '@/components/organisms/ModalNotification.vue'
import moment from 'moment'

@Component({
  components: {
    TitleBase,
    TitleTextBase,
    SelectBase,
    ButtonBase,
    InputWithLabel,
    StudentInformationHistory,
    StudentInformationHistoryNursing,
    NotificationList,
    ModalNotification,
  },
})
export default class History extends Mixins(QueryMethods, NursingBranch) {
  private branchId = Vue.prototype.$cookies.get('dataGdls').branchId

  private studentId = ''
  private nickname = ''

  private gradeOptionDatas: { text: string; value: number }[] = []
  private gradeSelectedData: number | null = null

  private schoolOptionDatas: { text: string; value: number }[] = []
  private schoolSelectedData: number | null = null

  private studentDatas: StudentResponseType[] = []

  private searchCount = 0
  private isProcessing = false
  private notificationDatas: Notification[] = []

  private readonly ONLY_TARGET = 1

  @Ref()
  modalNotification!: ModalNotification

  private mounted() {
    this.loadInitialize()
  }

  // 初回情報読み込み
  private async loadInitialize() {
    this.setParamsFromQuery()
    await this.loadSelectDatas()
    await this.loadNotifications()
    this.loadStudentDatas()
  }

  private async loadSelectDatas() {
    this.loadGrades()
    this.loadSchools()
  }

  private showNotification(id: number): void {
    this.modalNotification.loadNotification(id)
  }

  private async loadNotifications() {
    const params = ['role=teacher']
    Vue.prototype.$http.httpWithToken.get(`/notifications?${params.join('&')}`).then((res: any) => {
      this.notificationDatas = res.data.notifications.map(
        (notification: Notification) => {
          return {
            date: moment(notification.startedAt).format('YYYY/MM/DD'),
            title: notification.title,
            content: notification?.message,
            click: this.showNotification,
            variable: notification.id,
          }
        }
      )
    })
  }

  // 学年情報読み込み
  private async loadGrades() {
    Vue.prototype.$http.httpWithToken.get(`/grades`).then((res: any) => {
      this.gradeOptionDatas = res.data.map((grade: { id: number; name: string; code: string; sortNum: string }) => {
        return {
          text: grade.name,
          value: grade.id,
        }
      })
    })
  }

  // 学校情報読み込み
  private async loadSchools() {
    Vue.prototype.$http.httpWithToken.get(`/schools`, { params: { branchId: this.branchId } }).then((res: any) => {
      this.schoolOptionDatas = res.data.schools.map((school: { id: number; name: string }) => {
        return {
          text: school.name,
          value: school.id,
        }
      })
    })
  }

  // 検索
  private search() {
    this.setQueryFromParams()
    this.loadStudentDatas()
  }

  private getSearchParams(): any {
    // TODO: ページングは現状不要。追加する場合はこちらにページングパラメータの追加と、ページネータの実装が必要
    const params = {
      branchId: this.branchId,
    }

    // 教師ユーザの場合は対象生徒のみ絞り込み、それ以外の場合は全て取得
    const auth = Vue.prototype.$cookies.get('authGdls')
    if (auth.role == 'teacher') {
      params['teacherUserId'] = auth.currentApiUserId
      params['targetType'] = this.ONLY_TARGET
    }

    // 氏名
    if (this.nickname) {
      params['name'] = this.nickname
    }
    // ID
    if (this.studentId) {
      params['studentCode'] = this.studentId
    }
    // 学校
    if (this.schoolSelectedData) {
      params['schoolId'] = this.schoolSelectedData
    }
    // 学年
    if (this.gradeSelectedData) {
      params['gradeId'] = this.gradeSelectedData
    }
    return params
  }

  // 生徒情報取得
  private async loadStudentDatas() {
    // 固定パラメータ設定
    const params = this.getSearchParams()
    // 生徒情報を取得
    const { data }: { data: GetStudentsResponseType } = await Vue.prototype.$http.httpWithToken.get(`/students`, {
      params: params,
    })
    this.searchCount = data.count
    this.studentDatas = data.students
  }

  // クエリから検索条件を復元
  private setParamsFromQuery() {
    const params = this.getParamsObject()
    // 氏名
    if (params['name']) {
      this.nickname = params['name']
    }
    // 生徒ID(DB上はcode)
    if (params['id']) {
      this.studentId = params['id']
    }
    // 学校
    if (params['school']) {
      this.schoolSelectedData = params['school']
    }
    // 学年
    if (params['grade']) {
      this.gradeSelectedData = params['grade']
    }
  }

  // クエリに検索条件を設定
  private setQueryFromParams() {
    const params = {}
    // 氏名
    if (this.nickname) {
      params['name'] = this.nickname
    }
    // ID
    if (this.studentId) {
      params['id'] = this.studentId
    }
    // 学校
    if (this.schoolSelectedData) {
      params['school'] = this.schoolSelectedData
    }
    // 学年
    if (this.gradeSelectedData) {
      params['grade'] = this.gradeSelectedData
    }
    this.setUrlAsParams(params)
  }
}
